import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function PrescriptionOrderDetails() {
  const { id } = useParams();
  const { user } = useAuth();
  const [order, setOrder] = useState(null);
  const [couponCode, setCouponCode] = useState("");
  const [applying, setApplying] = useState(false);
  const [error, setError] = useState(null);
  console.log("OrderDetails");

  //   useEffect(() => {
  //     loadOrder();
  //   }, [id]);

  //   const loadOrder = () => {
  //     fetch(`http://localhost:3001/prescriptionOrders/${id}`)
  //       .then((res) => {
  //         res.json();
  //         console.log(res);
  //         console.log("order",order);

  //       })
  //       .then(setOrder);
  //   };

  useEffect(() => {
    const loadOrder = async () => {
      try {
        const res = await fetch(
          `https://cafedaru.shop/api/auth/prescriptionOrders/${id}`,
        );
        const data = await res.json();
        console.log(data);

        setOrder(data);
      } catch (err) {
        console.error(err);
      }
    };
    loadOrder();
  }, [id]);

  if (!order) {
    return <div>Loading...</div>;
  }
  const canPay = order.status === "process" && order.final > 0;
  //  `http://localhost:8000/api/prescription-orders/${order.id}/payment`,

  const token = localStorage.getItem("token");

  //const usern = localStorage.getItem("user");
  console.log("usern token:", token);

  const payOrder = async () => {
    // console.log("payOrder:", payOrder);
    console.log("User Login ID:", user.id);
    const response = await fetch(
      `https://cafedaru.shop/api/auth/basket/checkoutPharmacy/${order.id}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: user.id,
        }),
      },
    );

    const result = await response.json();
    console.log("result api:", result);

    if (result.success) {
      window.location.href = result.paymentUrl;
    }

    if (result.success) {
      // loadOrder();

      alert("Payment successful");
    }
  };

  const applyCoupon = async () => {
    try {
      setApplying(true);
      console.log("couponCode:", couponCode);
      const response = await fetch(
        `https://cafedaru.shop/api/coupons?code=${couponCode.toUpperCase()}`,
      );
      const result = await response.json();
      console.log(result);

      if (!result.success) {
        //  alert(result.message);
        setError(result.message);
        return;
      }

      // loadOrder();
    } finally {
      setApplying(false);
    }
  };

  return (
    <div>
      <h2>Prescription Order</h2>

      <div>
        <strong>Status:</strong> {order.status}
        {order.status === "process" && (
          <div className="info-box">در انتظار پرداخت</div>
        )}
        {order.status === "preparing" && (
          <div className="info-box">Your order is being prepared.</div>
        )}
        {order.status === "shipped" && (
          <div className="info-box">
            <p>Delivery Code: {order.deliveryCode}</p>
          </div>
        )}
        {order.status === "delivered" && (
          <div className="success-box">Order delivered successfully.</div>
        )}
      </div>

      <hr />

      <div>Total: {order.total}</div>

      <div>Discount: {order.discount}</div>

      <div>Final: {order.final}</div>

      <hr />

      {order.status === "process" && (
        <div className="coupon-box">
          <h3>Coupon</h3>

          <input
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value)}
            placeholder="Coupon code"
          />

          <button onClick={applyCoupon} disabled={applying}>
            Apply Coupon
          </button>

          {error && <div style={{ color: "red" }}>Error: {error}</div>}
        </div>
      )}
      <hr />

      <h3>Address</h3>

      <div>{order.selectedAddress?.address}</div>
      <div>
        <hr />
        {order.selectedAddress && (
          <div className="selected-address">
            <h4>Selected Address</h4>

            <p>
              {order.selectedAddress.name} {order.selectedAddress.lastName}
            </p>

            <p>{order.selectedAddress.address}</p>

            <p>{order.selectedAddress.phone}</p>
          </div>
        )}
      </div>

      <hr />

      <h3>Order Details</h3>
      {/* 
      {order.items.map((item, index) => (
        <div key={index}>
          <p>Type: {item.type}</p>
        </div>
      ))} */}

      {order.items.length === 0 ? (
        <p>No items</p>
      ) : (
        order.items.map((item, index) => (
          <div key={index} className="prescription-item">
            {item.image && <img src={item.image} alt="" width="120" />}
            <p>Type: {item.type}</p>
            {item.type === "imagePrescription" && (
              <>
                <p>سفارش دارو با عکس نسخه</p>
              </>
            )}
            {item.type === "insurancePrescription" && (
              <>
                <p>doctorName: {item.doctorName}</p>
                <p>insuranceType: {item.insuranceType}</p>
                <p>nationalCode: {item.nationalCode}</p>
                <p>trackingCode: {item.trackingCode}</p>
              </>
            )}
            {item.type === "otc" && (
              <>
                <p>Drug: {item.drugName}</p>

                <p>Dose: {item.drugDose}</p>

                <p>Qty: {item.qty}</p>
              </>
            )}
          </div>
        ))
      )}

      <h3>Comment</h3>

      <textarea value={order.comment} />

      <hr />

      <button disabled={!canPay} onClick={payOrder}>
        Pay
      </button>

      
    </div>
  );
}
